module.exports = __webpack_public_path__ + "static/media/aboutimagecolor.8c17f94e.jpg";